import { create } from 'zustand';

export interface AppSelectorContext {
  /** Restrict to these app types only */
  allowAppType?: string[];
  /** Exclude these app types */
  disableAppType?: string[];
  /** Source context — PLAYLIST restricts to playlist-compatible apps */
  source?: 'PLAYLIST';
  /** Hide the Popular Apps section and "All Apps" label */
  hidePopularApps?: boolean;
  /** Enforce specific tags (e.g. ['designer'] for Designer context) */
  enforceTags?: string[];
  /** Additional must-match tags */
  mustTags?: string[];
  /** When true, created assets will have engage: true (Engage page context) */
  engage?: boolean;
  /** Override folder path (used when opened from asset picker in playlist page) */
  currentPath?: string;
  /** When true, Canvas close flow will set reopenAssetPicker param to re-open SelectAssetModal */
  fromAssetPicker?: boolean;
}

interface AppSelectorState {
  isOpen: boolean;
  context: AppSelectorContext;
  openAppSelector: (context?: AppSelectorContext) => void;
  closeAppSelector: () => void;
}

export const useAppSelectorStore = create<AppSelectorState>((set) => ({
  isOpen: false,
  context: {},
  openAppSelector: (context = {}) => set({ isOpen: true, context }),
  closeAppSelector: () => set({ isOpen: false, context: {} }),
}));
